
















import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import QuestionModel from "@/model/QuestionModel";
@Component
export default class ProgressBar extends Vue {
  @Prop()
  questions!: QuestionModel[];
  @Prop()
  currentQuestion!: QuestionModel;

  isCurrent(question: QuestionModel): boolean {
    return question.uid === this.currentQuestion.uid;
  }

  @Emit()
  questionSelected(index: number) {
    return index;
  }
}
